import React, { useState } from "react";
import EditAssignment from "../../../components/content/EditAssignment/EditAssignment";
import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import {
  useUpdateAssignmentMutation,
  useAddAssignmentMutation,
  GetGeneratedContentDocument,
  GetContentByIdDocument,
} from "../../../graphql/generated/graphql";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";

const EditAssignmentModalContainer = ({
  visible,
  onClose,
  courseId,
  initialContent,
  currentAssignmentName,
  moduleName,
}) => {
  const { isMedium } = useResponsiveScreen();
  const [assignmentName, setAssignmentName] = useState(currentAssignmentName || "");

  const isNewAssignment = currentAssignmentName === "";

  const [updateAssignment] = useUpdateAssignmentMutation({
    refetchQueries: [
      {
        query: GetContentByIdDocument,
      },
    ],
  });
  const [addAssignment] = useAddAssignmentMutation({
    refetchQueries: [
      {
        query: GetGeneratedContentDocument,
      },
    ],
  });

  const onChangeAssignmentName = (text) => {
    setAssignmentName(text);
  };

  const handleSaveAssignment = async (Html, newAssignmentName) => {
    const cleanedHtml = Html.replace(/\n\s+/g, "").trim();
    const encodedHtml = encodeURIComponent(cleanedHtml);

    const variables = {
      courseId,
      moduleName,
      newAssignmentName: newAssignmentName || assignmentName,
      updatedHtml: encodedHtml,
    };

    try {
      if (isNewAssignment) {
        await addAssignment({
          variables,
        });
      } else {
        await updateAssignment({
          variables: {
            ...variables,
            currentAssignmentName: currentAssignmentName,
          },
        });
      }
      onClose();
    } catch (error) {
      console.error(isNewAssignment ? "Error adding assignment" : "Error updating assignment", error);
    }
  };

  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      showCloseButton={true}
      title={isNewAssignment ? "Add Assignment" : "Edit Assignment"}
      style={{ width: isMedium ? "50%" : "90%" }}>
      <EditAssignment
        onClose={onClose}
        onSave={handleSaveAssignment}
        initialContent={initialContent}
        newAssignmentName={assignmentName}
        onChangeAssignmentName={onChangeAssignmentName}
        buttonText={isNewAssignment ? "Add" : "Save"}
      />
    </CustomModal>
  );
};

export default EditAssignmentModalContainer;
